// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postMessage = (type: string, data?: any) =>
  window.parent.postMessage(JSON.stringify({ ...data, type }), "*");
